import elLocale from 'element-ui/lib/locale/lang/el'
import home from './el/home'

const el = {
    language: 'Deutsch',
    message: {
        'home': {
            ...home,
            enterEmail: 'Παρακαλώ εισάγετε email',
            save: 'Αποθήκευση',
            saveSuccess: 'Αποθηκεύτηκε με επιτυχία',
            pointHistory: 'Ιστορικό πόντων',
            type: 'Τύπος',
            remark: 'Σημείωση',
            pendingComment: 'Σε εκκρεμότητα αξιολόγησης',
            commented: 'Αξιολογήθηκε',
            selectDate: 'Επιλογή ημερομηνίας',
            loginSuccess: 'Επιτυχής σύνδεση',
            loginFail: 'Αποτυχία σύνδεσης',
            close: 'Κλείσιμο',
            required: 'Υποχρεωτικό',
            nickname: 'Ψευδώνυμο',
            enterNickname: 'Παρακαλώ εισάγετε ψευδώνυμο',
            gender: 'Φύλο',
            male: 'Άνδρας',
            female: 'Γυναίκα',
            secret: 'Απόρρητο',
            birthday: 'Γενέθλια',
            checkoutLoadFailed: 'Αποτυχία φόρτωσης στοιχείων πληρωμής. Δοκιμάστε ξανά αργότερα.',
            checkoutErrorTitle: 'Ειδοποίηση',
            goAddAddress: 'Προσθήκη διεύθυνσης παράδοσης',
            shop_order_selectOrAddAddress: 'Προσθέστε πρώτα μια διεύθυνση παράδοσης και ορίστε την ως προεπιλογή πριν την ολοκλήρωση της παραγγελίας.',
            shop_order_cartEmpty: 'Το καλάθι είναι άδειο, δεν είναι δυνατή η ολοκλήρωση.',
            shop_order_cartHasNotActive: 'Υπάρχουν μη δημοσιευμένα ή μη έγκυρα προϊόντα, δεν είναι δυνατή η ολοκλήρωση.',
            shop_order_cartHasNotMarketable: 'Υπάρχουν προϊόντα που έχουν αποσυρθεί, δεν είναι δυνατή η ολοκλήρωση.',
            shop_order_cartHasLowStock: 'Ανεπαρκές απόθεμα, δεν είναι δυνατή η ολοκλήρωση.',
            shop_order_cartHasExpiredGoods: 'Ορισμένα προϊόντα του καταστήματος έχουν λήξει, δεν είναι δυνατή η ολοκλήρωση.',
            shop_order_typeIsNull: 'Δεν αναγνωρίστηκε ο τύπος παραγγελίας, ελέγξτε τον τύπο προϊόντος.',
            shop_order_goodsNotFound: 'Οι πληροφορίες προϊόντος δεν υπάρχουν ή έχουν διαγραφεί.',
            shop_order_giftNotForSale: 'Τα δώρα δεν μπορούν να αγοραστούν απευθείας.',
            common_message_badRequest: 'Μη έγκυρο αίτημα, ελέγξτε το προϊόν και τις παραμέτρους.',
        },
    },
    '手机号码最小长度为8位': 'Το ελάχιστο μήκος του αριθμού κινητού τηλεφώνου είναι 8 ψηφία',
    '邮箱账号名称最小长度为6位': 'Το ελάχιστο μήκος του ονόματος λογαριασμού email είναι 6 χαρακτήρες',
    '邮箱只能包含英文，数字等字符': 'Το γραμματοκιβώτιο μπορεί να περιέχει μόνο χαρακτήρες όπως αγγλικά και αριθμούς',
    '请选择正确的收货地址': 'Παρακαλώ επιλέξτε τη σωστή διεύθυνση αποστολής',
    Dict_language_status_0: 'Απενεργοποιημένο',
    Dict_language_status_1: 'Ενεργοποιημένο',
    Dict_member_label_type_1: 'Ετικέτα συνθήκης',
    Dict_member_label_type_2: 'Χειροκίνητη ετικέτα',
    Dict_member_level_type_0: 'Επίπεδο κατανάλωσης (LV)',
    Dict_member_level_type_1: 'Συνδρομητικό μέλος (VIP)',
    Dict_member_growth_action_type_1: 'Υποβολή παραγγελίας',
    Dict_member_growth_action_type_2: 'Καθημερινή σύνδεση',
    Dict_member_growth_action_type_3: 'Δημοσίευση αξιολόγησης',
    Dict_member_growth_action_type_4: 'Συμπλήρωση προφίλ',
    Dict_paid_member_payment_type_0: 'Πληρωμή με υπόλοιπο',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Έγκυρο',
    Dict_paid_member_record_status_1: 'Έληξε',
    Dict_paid_member_record_status_2: 'Επιστράφηκε',
    Dict_point_lottery_prize_type_0: 'Πόντοι',
    Dict_point_lottery_prize_type_1: 'Κουπόνι',
    Dict_point_lottery_prize_type_2: 'Φυσικό έπαθλο',
    Dict_point_lottery_prize_type_3: 'Ευχαριστούμε για τη συμμετοχή',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'Εσωτερικό μήνυμα',
    Dict_notification_channel_type_3: 'Ειδοποίηση push',
    Dict_announcement_status_0: 'Πρόχειρο',
    Dict_announcement_status_1: 'Δημοσιεύτηκε',
    Dict_announcement_status_2: 'Αποσύρθηκε',
    Dict_live_permission_status_0: 'Δεν υποβλήθηκε',
    Dict_live_permission_status_1: 'Υπό αξιολόγηση',
    Dict_live_permission_status_2: 'Ενεργοποιήθηκε',
    Dict_live_permission_status_3: 'Απορρίφθηκε',
    Dict_live_room_status_0: 'Δεν ξεκίνησε',
    Dict_live_room_status_1: 'Σε ζωντανή μετάδοση',
    Dict_live_room_status_2: 'Ολοκληρώθηκε',
    Dict_live_room_status_3: 'Μη φυσιολογική διακοπή',
    Dict_live_room_type_0: 'Ζωντανή μετάδοση πλατφόρμας',
    Dict_live_room_type_1: 'Ζωντανή μετάδοση εμπόρου',
    Dict_store_type_0: 'Ατομικό κατάστημα',
    Dict_store_type_1: 'Εταιρικό κατάστημα',
    Dict_store_sign_status_0: 'Σε αναμονή υπογραφής',
    Dict_store_sign_status_1: 'Υπογράφηκε',
    Dict_store_sign_status_2: 'Λύθηκε',
    Dict_store_business_change_status_0: 'Σε αναμονή αξιολόγησης',
    Dict_store_business_change_status_1: 'Εγκρίθηκε',
    Dict_store_business_change_status_2: 'Απορρίφθηκε',
    Dict_decoration_page_type_0: 'Αρχική σελίδα',
    Dict_decoration_page_type_1: 'Σελίδα κατηγορίας',
    Dict_decoration_page_type_2: 'Σελίδα καμπάνιας',
    Dict_decoration_page_type_3: 'Προσαρμοσμένη σελίδα',
    Dict_decoration_status_0: 'Πρόχειρο',
    Dict_decoration_status_1: 'Δημοσιεύτηκε',
    Dict_decoration_popup_trigger_page_0: 'Αρχική πλατφόρμας',
    Dict_decoration_popup_trigger_page_1: 'Κέντρο μελών',
    Dict_decoration_popup_trigger_page_2: 'Επιτυχής πληρωμή',
    Dict_decoration_popup_target_user_0: 'Όλοι οι χρήστες',
    Dict_decoration_popup_target_user_1: 'Δωρεάν μέλη',
    Dict_decoration_popup_target_user_2: 'Συνδρομητικά μέλη',
    Dict_decoration_popup_frequency_0: 'Μία φορά μόνιμα',
    Dict_decoration_popup_frequency_1: 'Κάθε επίσκεψη',
    Dict_decoration_popup_frequency_2: 'Προσαρμοσμένη συχνότητα',
    Dict_track_event_type_page_view: 'Προβολή σελίδας',
    Dict_track_event_type_click: 'Κλικ',
    Dict_track_event_type_add_to_cart: 'Προσθήκη στο καλάθι',
    Dict_track_event_type_search: 'Αναζήτηση',
    Dict_track_event_type_purchase: 'Αγορά',
    Dict_track_event_type_live_watch: 'Παρακολούθηση ζωντανά',
    Dict_reconcile_period_type_0: 'Ημερήσιο',
    Dict_reconcile_period_type_1: 'Εβδομαδιαίο',
    Dict_reconcile_period_type_2: 'Μηνιαίο',
    Dict_store_settlement_status_0: 'Σε αναμονή εκκαθάρισης',
    Dict_store_settlement_status_1: 'Εκκαθαρίστηκε',
    Dict_distributor_status_0: 'Σε αναμονή αξιολόγησης',
    Dict_distributor_status_1: 'Αξιολογήθηκε',
    Dict_distributor_status_2: 'Απορρίφθηκε',
    Dict_distribution_commission_type_0: 'Άμεση προμήθεια',
    Dict_distribution_commission_type_1: 'Έμμεση προμήθεια',
    Dict_configuration_status_0: 'Απενεργοποιημένο',
    Dict_configuration_status_1: 'Ενεργοποιημένο',
    ...elLocale
}

export default el